import type { IUserSerialized } from '@bridebook/web/lib/users/types';

const getAuthStatus = ({ user }: { user?: IUserSerialized | null }): boolean => Boolean(user);

export default getAuthStatus;
